
import Utils from '~/assets/utils.js'
import Head from '~/assets/head.js'

export default {
  mixins: [Head.titleMixin],
  async asyncData ({ $content }) {
    const today = new Date()
    today.setHours(0, 0, 0, 0)

    let allPosts = await $content('posts', { deep: true })
      .only(['project_title', 'dir', 'slug', 'date', 'hero', 'path', 'project_desc', 'excerpt_desc', 'project_end', 'project_start', 'project_link'])
      .fetch()

    allPosts.map((post) => {
      if (!post.date) {
        post.date = new Date(0)
      }
      post.color = Utils.getRandColor()
      if (!post.project_end) {
        post.project_end = today
      } else {
        post.project_end = new Date(post.project_end)
        post.project_end.setHours(0, 0, 0, 0)
      }

      if (post.project_start) {
        post.project_start = new Date(post.project_start)
        post.project_start.setHours(0, 0, 0, 0)
      }
      return post
    })

    allPosts = allPosts.filter(post => post.project_title)
    allPosts.sort((a, b) => (a.project_end > b.project_end ? 1 : -1))
    return {
      today,
      posts: allPosts.reverse(),
      title: 'My Projects',
      description: 'A timeline portfolio of all my projects.'
    }
  },
  data () {
    return {
      hero: '/images/posts/projects/pytorch_code_blur.png'
    }
  },
  computed: {
    denseTimeline () {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  methods: {
    // Random color generation from here: http://blog.adamcole.ca/2011/11/simple-javascript-rainbow-color.html
    getRandColor () {
      return Utils.getRandColor()
    },
    getBW (v) {
      v = v * 0.65 + 0.35
      return Utils.bwStop(v)
    },
    prettifyDate (date) {
      return Utils.prettifyDate2(date)
    }
  }
}
